import { inject, provide, toRefs, reactive, readonly } from 'vue'

import useAxiosResponse from '@/composables/common/useAxiosResponse'
import bookingArmService from '@/services/api/booking'

export const STATUS_ITEMS = [
  {
    text: 'Booked',
    value: 'Booked'
  },
  {
    text: 'Cancelled',
    value: 'Cancelled'
  },
  {
    text: 'Completed',
    value: 'Confirmed'
  }
]

export interface State {
  page: number
  statusSelected: typeof STATUS_ITEMS
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useBaseBookingListView = () => {
  const state = reactive<State>({
    page: 1,
    statusSelected: []
  })

  const bookingListQuery = useAxiosResponse(async () => {
    return await bookingArmService.fetchBookings(state.page, { requestErrorEnabled: true })
  }, { loadingMode: 'normal' })

  // #region Actions

  const handleChangePage = (value: number): void => {
    state.page = value
    bookingListQuery.execute()
  }

  // #endregion

  return {
    ...toRefs(readonly(state)),
    bookingListQuery,
    handleChangePage
  }
}

export const defaultKey = Symbol('view:booking-list')

export default function useBookingListView (): ReturnType<typeof useBaseBookingListView> {
  const result = inject<ReturnType<typeof useBaseBookingListView> | undefined>(defaultKey, undefined)

  if (result === undefined) {
    const newResult = useBaseBookingListView()
    provide(defaultKey, newResult)
    return newResult
  }

  return result
}
